import { gql } from '@apollo/client';

export default gql`
  mutation updateSquad($input: UpdateSquadInput!) {
    updateSquad(input: $input) {
      id
    }
  }
`;
